"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ECR Public gallery
 * This is an API used in Spencer gallery API Gateway to proxy request to ECR Public.
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepositoryCatalogSortFieldToJSON = exports.RepositoryCatalogSortFieldFromJSONTyped = exports.RepositoryCatalogSortFieldFromJSON = exports.RepositoryCatalogSortField = void 0;
/**
 *
 * @export
 */
exports.RepositoryCatalogSortField = {
    DownloadCount: 'DOWNLOAD_COUNT'
};
function RepositoryCatalogSortFieldFromJSON(json) {
    return RepositoryCatalogSortFieldFromJSONTyped(json, false);
}
exports.RepositoryCatalogSortFieldFromJSON = RepositoryCatalogSortFieldFromJSON;
function RepositoryCatalogSortFieldFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.RepositoryCatalogSortFieldFromJSONTyped = RepositoryCatalogSortFieldFromJSONTyped;
function RepositoryCatalogSortFieldToJSON(value) {
    return value;
}
exports.RepositoryCatalogSortFieldToJSON = RepositoryCatalogSortFieldToJSON;
